exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login .card{box-shadow:2px 2px 4px 0 #a7a7a7;border-radius:10px}.login .card form .row{margin:20px 0}.login .card form .pass{font-size:.8rem}.login li{list-style-type:none}.login .card-profile{padding:10px;background-color:#fff;box-shadow:2px 2px 4px 0 #a7a7a7;border-radius:10px}.login .card-profile:hover{box-shadow:2px 2px 8px 0 #a7a7a7}.login .card-profile p{margin-bottom:0}", ""]);

// exports
